<template>
  <el-tooltip v-bind="$attrs" :auto-close="autoClose">
    <template
      v-for="(_, scopedSlotName) in $slots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>

    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </el-tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useWindowSize } from '@shared/composables/use-window-size'

const { isMobileScreen } = useWindowSize()

const autoClose = computed(() => (isMobileScreen ? 4000 : 0)) //miliseconds
</script>
